export const TEST_ID = 'toastProvider';

export const DEFAULT_TOAST_TIMEOUT = 3000;
